var map = {
	"./AssessmentReport.svg": 244,
	"./Daily.svg": 245,
	"./EnrolledPatientReport.svg": 246,
	"./Failed.svg": 106,
	"./Ghana.svg": 247,
	"./Info-blue.svg": 170,
	"./Info-green.svg": 169,
	"./Kenya.svg": 248,
	"./MOH.svg": 249,
	"./PatientStatusReport.svg": 250,
	"./Pending.svg": 171,
	"./Permanent.svg": 251,
	"./Presc.svg": 252,
	"./ScreenedReport.svg": 253,
	"./Sierra Leone.svg": 254,
	"./Tanzania.svg": 255,
	"./US.svg": 256,
	"./app-logo.svg": 55,
	"./arrow-right-small.svg": 257,
	"./assignQuickSightUser.svg": 258,
	"./avatar-o.svg": 259,
	"./bin.svg": 172,
	"./caret-down-grey.svg": 167,
	"./caret-down-white.svg": 260,
	"./checkbox-disabled.svg": 173,
	"./checkbox-empty.svg": 143,
	"./checkbox.svg": 144,
	"./close.svg": 174,
	"./download.svg": 107,
	"./dropdown.svg": 175,
	"./edit.svg": 108,
	"./hidePass.svg": 79,
	"./home.svg": 176,
	"./info-grey.svg": 261,
	"./info-orange.svg": 168,
	"./insights.svg": 262,
	"./no-icon.svg": 202,
	"./plus.svg": 177,
	"./power-switch.svg": 166,
	"./quickSightUser.svg": 263,
	"./reports.svg": 178,
	"./reset.svg": 179,
	"./search.svg": 180,
	"./send-disabled.svg": 181,
	"./send.svg": 182,
	"./showPass.svg": 66,
	"./success-blue.svg": 183,
	"./success-green.svg": 184,
	"./tick.svg": 185,
	"./user-role-assigned.svg": 186,
	"./user-role-not-assigned.svg": 105,
	"./warning.svg": 187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 201;